/**
 * Legù Exit Intent Popup Script
 * File: assets/legu-exit-intent.js
 * Multilingual support: IT (default), EN, ES, DE, FR, PT
 * Auto-detects language from URL path: /en, /es, /de, /fr, /pt (+ /pt-PT, /pt-BR, /en-us, /en-gb, ecc.)
 */

// Multilingual translations
const LEGU_TRANSLATIONS = {
  it: {
    stepCounter: 'Passo __NUM__ di 3',
    title1: 'Aspetta un momento!',
    intro1: 'La tua opinione è preziosa per migliorare la tua esperienza nel nostro shop di prodotti a base di legumi 100% italiani.',
    question1: 'Cosa ti ha fermato dall’acquistare oggi?',
    multipleAnswers: '(puoi selezionare più opzioni)',
    reason1: 'Prezzo troppo alto per il mio budget',
    reason2: 'Costo spedizione (sotto 49€)',
    reason3: 'Non sono sicuro/a del gusto dei prodotti',
    reason4: 'Non so quali prodotti provare per la prima volta',
    reason5: 'Vorrei più informazioni nutrizionali o sugli ingredienti',
    reason6: 'Altro motivo',
    reasonOtherPlaceholder: 'Puoi specificare il motivo…',
    btnContinue: 'Continua',
    title2: 'Cosa ti aiuterebbe a completare l’acquisto oggi?',
    intro2: 'Il tuo feedback ci aiuta a migliorare l’esperienza di chi cerca un’alimentazione sana, gustosa e senza glutine.',
    suggestionPlaceholder: 'Condividi con noi cosa renderebbe più semplice il tuo acquisto…',
    btnBack: 'Indietro',
    title3: 'Un ultimo passo!',
    emailIntro: 'Lasciaci la tua email per ricevere consigli personalizzati sui prodotti più adatti a te e offerte esclusive dal mondo LEGÙ®.',
    emailPlaceholder: 'La tua email',
    emailNote: 'Analizzeremo attentamente le tue risposte per offrirti la migliore esperienza d’acquisto e aiutarti a scoprire i prodotti LEGÙ® perfetti per le tue esigenze.',
    btnSubmit: 'Invia feedback',
    btnSubmitting: 'Invio in corso…',
    successTitle: 'Grazie del tuo prezioso feedback!',
    successMessage: 'Abbiamo ricevuto le tue risposte e le analizzeremo con cura per migliorare la tua esperienza d’acquisto. LEGÙ® cresce anche grazie al tuo contributo: insieme promuoviamo un’alimentazione più sana e sostenibile.',
    notSpecified: 'Non specificato'
  },
  en: {
    stepCounter: 'Step __NUM__ of 3',
    title1: 'Hold on a moment!',
    intro1: 'Your opinion is valuable in helping us improve your experience in our shop of 100% Italian legume-based products.',
    question1: 'What stopped you from buying today?',
    multipleAnswers: '(you can select multiple options)',
    reason1: 'Price too high for my budget',
    reason2: 'Shipping cost (under €49)',
    reason3: 'I’m not sure about the taste of the products',
    reason4: 'I don’t know which products to try first',
    reason5: 'I’d like more nutritional or ingredient information',
    reason6: 'Other reason',
    reasonOtherPlaceholder: 'You can specify the reason…',
    btnContinue: 'Continue',
    title2: 'What would help you complete your purchase today?',
    intro2: 'Your feedback helps us improve the experience for those looking for a healthy, tasty, gluten-free diet.',
    suggestionPlaceholder: 'Share with us what would make your purchase easier…',
    btnBack: 'Back',
    title3: 'One last step!',
    emailIntro: 'Leave us your email to receive personalised advice on the products best suited to you and exclusive offers from the LEGÙ® world.',
    emailPlaceholder: 'Your email',
    emailNote: 'We will carefully analyse your answers to give you the best shopping experience and help you discover the LEGÙ® products perfect for your needs.',
    btnSubmit: 'Send feedback',
    btnSubmitting: 'Sending…',
    successTitle: 'Thank you for your valuable feedback!',
    successMessage: 'We have received your answers and will analyse them carefully to improve your shopping experience. LEGÙ® grows thanks to your contribution too: together we promote a healthier and more sustainable diet.',
    notSpecified: 'Not specified'
  },
  es: {
    stepCounter: 'Paso __NUM__ de 3',
    title1: '¡Espera un momento!',
    intro1: 'Tu opinión es valiosa para mejorar tu experiencia en nuestra tienda de productos a base de legumbres 100% italianas.',
    question1: '¿Qué te ha impedido comprar hoy?',
    multipleAnswers: '(puedes seleccionar varias opciones)',
    reason1: 'Precio demasiado alto para mi presupuesto',
    reason2: 'Coste de envío (por debajo de 49€)',
    reason3: 'No estoy seguro/a del sabor de los productos',
    reason4: 'No sé qué productos probar por primera vez',
    reason5: 'Querría más información nutricional o sobre los ingredientes',
    reason6: 'Otro motivo',
    reasonOtherPlaceholder: 'Puedes especificar el motivo…',
    btnContinue: 'Continuar',
    title2: '¿Qué te ayudaría a completar la compra hoy?',
    intro2: 'Tu feedback nos ayuda a mejorar la experiencia de quien busca una alimentación sana, sabrosa y sin gluten.',
    suggestionPlaceholder: 'Comparte con nosotros qué haría más sencilla tu compra…',
    btnBack: 'Atrás',
    title3: '¡Un último paso!',
    emailIntro: 'Déjanos tu email para recibir consejos personalizados sobre los productos más adecuados para ti y ofertas exclusivas del mundo LEGÙ®.',
    emailPlaceholder: 'Tu email',
    emailNote: 'Analizaremos atentamente tus respuestas para ofrecerte la mejor experiencia de compra y ayudarte a descubrir los productos LEGÙ® perfectos para tus necesidades.',
    btnSubmit: 'Enviar feedback',
    btnSubmitting: 'Enviando…',
    successTitle: '¡Gracias por tu valioso feedback!',
    successMessage: 'Hemos recibido tus respuestas y las analizaremos con cuidado para mejorar tu experiencia de compra. LEGÙ® crece también gracias a tu aportación: juntos promovemos una alimentación más sana y sostenible.',
    notSpecified: 'No especificado'
  },
  de: {
    stepCounter: 'Schritt __NUM__ von 3',
    title1: 'Einen Moment bitte!',
    intro1: 'Ihre Meinung hilft uns, Ihr Einkaufserlebnis in unserem Shop für Produkte auf Basis von 100% italienischen Hülsenfrüchten zu verbessern.',
    question1: 'Was hat Sie heute vom Kauf abgehalten?',
    multipleAnswers: '(Mehrfachauswahl möglich)',
    reason1: 'Preis zu hoch für mein Budget',
    reason2: 'Versandkosten (unter 49€)',
    reason3: 'Ich bin mir beim Geschmack der Produkte nicht sicher',
    reason4: 'Ich weiß nicht, welche Produkte ich zuerst probieren soll',
    reason5: 'Ich möchte mehr Nähr- oder Zutateninformationen',
    reason6: 'Anderer Grund',
    reasonOtherPlaceholder: 'Sie können den Grund angeben…',
    btnContinue: 'Weiter',
    title2: 'Was würde Ihnen helfen, den Kauf heute abzuschließen?',
    intro2: 'Ihr Feedback hilft uns, das Erlebnis für alle zu verbessern, die eine gesunde, schmackhafte und glutenfreie Ernährung suchen.',
    suggestionPlaceholder: 'Teilen Sie uns mit, was Ihren Einkauf einfacher machen würde…',
    btnBack: 'Zurück',
    title3: 'Ein letzter Schritt!',
    emailIntro: 'Hinterlassen Sie uns Ihre E-Mail-Adresse, um persönliche Empfehlungen zu den für Sie am besten geeigneten Produkten und exklusive Angebote aus der LEGÙ®-Welt zu erhalten.',
    emailPlaceholder: 'Ihre E-Mail-Adresse',
    emailNote: 'Wir werden Ihre Antworten sorgfältig analysieren, um Ihnen das beste Einkaufserlebnis zu bieten und Ihnen zu helfen, die für Ihre Bedürfnisse perfekten LEGÙ®-Produkte zu entdecken.',
    btnSubmit: 'Feedback senden',
    btnSubmitting: 'Wird gesendet…',
    successTitle: 'Vielen Dank für Ihr wertvolles Feedback!',
    successMessage: 'Wir haben Ihre Antworten erhalten und werden sie sorgfältig analysieren, um Ihr Einkaufserlebnis zu verbessern. LEGÙ® wächst auch dank Ihres Beitrags: Gemeinsam fördern wir eine gesündere und nachhaltigere Ernährung.',
    notSpecified: 'Nicht angegeben'
  },
  fr: {
    stepCounter: 'Étape __NUM__ sur 3',
    title1: 'Attendez un instant !',
    intro1: 'Votre avis est précieux pour améliorer votre expérience dans notre boutique de produits à base de légumineuses 100% italiennes.',
    question1: 'Qu’est-ce qui vous a empêché d’acheter aujourd’hui ?',
    multipleAnswers: '(plusieurs choix possibles)',
    reason1: 'Prix trop élevé pour mon budget',
    reason2: 'Frais de livraison (en dessous de 49€)',
    reason3: 'Je ne suis pas sûr(e) du goût des produits',
    reason4: 'Je ne sais pas quels produits essayer en premier',
    reason5: 'J’aimerais plus d’informations nutritionnelles ou sur les ingrédients',
    reason6: 'Autre raison',
    reasonOtherPlaceholder: 'Vous pouvez préciser la raison…',
    btnContinue: 'Continuer',
    title2: 'Qu’est-ce qui vous aiderait à finaliser votre achat aujourd’hui ?',
    intro2: 'Vos retours nous aident à améliorer l’expérience de ceux qui recherchent une alimentation saine, savoureuse et sans gluten.',
    suggestionPlaceholder: 'Partagez avec nous ce qui faciliterait votre achat…',
    btnBack: 'Retour',
    title3: 'Une dernière étape !',
    emailIntro: 'Laissez-nous votre e-mail pour recevoir des conseils personnalisés sur les produits les plus adaptés à vous et des offres exclusives du monde LEGÙ®.',
    emailPlaceholder: 'Votre e-mail',
    emailNote: 'Nous analyserons attentivement vos réponses pour vous offrir la meilleure expérience d’achat et vous aider à découvrir les produits LEGÙ® parfaits pour vos besoins.',
    btnSubmit: 'Envoyer le feedback',
    btnSubmitting: 'Envoi en cours…',
    successTitle: 'Merci pour votre précieux feedback !',
    successMessage: 'Nous avons reçu vos réponses et nous les analyserons avec soin pour améliorer votre expérience d’achat. LEGÙ® grandit aussi grâce à votre contribution : ensemble nous promouvons une alimentation plus saine et plus durable.',
    notSpecified: 'Non spécifié'
  },
  pt: {
    stepCounter: 'Passo __NUM__ de 3',
    title1: 'Espere um momento!',
    intro1: 'A sua opinião é preciosa para melhorar a sua experiência na nossa loja de produtos à base de leguminosas 100% italianas.',
    question1: 'O que o impediu de comprar hoje?',
    multipleAnswers: '(pode selecionar várias opções)',
    reason1: 'Preço demasiado alto para o meu orçamento',
    reason2: 'Custo de envio (abaixo de 49€)',
    reason3: 'Não tenho a certeza do sabor dos produtos',
    reason4: 'Não sei que produtos experimentar pela primeira vez',
    reason5: 'Gostaria de mais informações nutricionais ou sobre os ingredientes',
    reason6: 'Outro motivo',
    reasonOtherPlaceholder: 'Pode especificar o motivo…',
    btnContinue: 'Continuar',
    title2: 'O que o ajudaria a concluir a compra hoje?',
    intro2: 'O seu feedback ajuda-nos a melhorar a experiência de quem procura uma alimentação saudável, saborosa e sem glúten.',
    suggestionPlaceholder: 'Partilhe connosco o que tornaria mais simples a sua compra…',
    btnBack: 'Voltar',
    title3: 'Um último passo!',
    emailIntro: 'Deixe-nos o seu email para receber conselhos personalizados sobre os produtos mais adequados para si e ofertas exclusivas do mundo LEGÙ®.',
    emailPlaceholder: 'O seu email',
    emailNote: 'Analisaremos atentamente as suas respostas para lhe oferecer a melhor experiência de compra e ajudá-lo a descobrir os produtos LEGÙ® perfeitos para as suas necessidades.',
    btnSubmit: 'Enviar feedback',
    btnSubmitting: 'A enviar…',
    successTitle: 'Obrigado pelo seu precioso feedback!',
    successMessage: 'Recebemos as suas respostas e vamos analisá-las com cuidado para melhorar a sua experiência de compra. LEGÙ® cresce também graças à sua contribuição: juntos promovemos uma alimentação mais saudável e sustentável.',
    notSpecified: 'Não especificado'
  }
};

// Precise language detection from URL path.
// Matches /en, /en-us, /pt-PT, /pt-BR, /fr/, /es/ecc. but NOT false positives like /engineering or /entrance.
function leguDetectLanguage() {
  const path = window.location.pathname || '/';
  const match = path.match(/^\/(en|es|de|fr|pt)(?:-[a-z]{2})?(?:\/|$)/i);
  return match ? match[1].toLowerCase() : 'it';
}

document.addEventListener('DOMContentLoaded', function() {
  const currentLanguage = leguDetectLanguage();
  const translations = LEGU_TRANSLATIONS[currentLanguage] || LEGU_TRANSLATIONS.it;

  // Detect if device is desktop
  function leguIsDesktop() {
    return window.innerWidth >= 1024 && !('ontouchstart' in window);
  }

  // Variables for exit intent control
  let leguExitIntentShown = false;
  let leguHasScrolledThreshold = false;
  const leguCookieName = 'leguExitIntentShown';
  const leguCookieDuration = 7; // Days
  let leguCurrentStep = 1;
  const leguTotalSteps = 3;
  const leguScrollThreshold = 35; // Scroll percentage required

  // Cookie management
  function leguGetCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function leguSetCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  // DOM elements
  const leguOverlay = document.getElementById('legu-exit-intent-overlay');
  const leguCloseBtn = document.getElementById('legu-exit-intent-close');
  const leguForm = document.getElementById('legu-exit-intent-form');
  const leguSuccessMessage = document.getElementById('legu-success-message');
  const leguProgressBar = document.getElementById('legu-progress-bar');
  const leguSteps = document.querySelectorAll('.legu-step');
  const leguNextButtons = document.querySelectorAll('.legu-next-step');
  const leguBackButtons = document.querySelectorAll('.legu-back-step');
  const leguOtherCheckbox = document.getElementById('legu-other');
  const leguOtherReasonContainer = document.getElementById('legu-other-reason-container');

  // Update content with translations
  function updateContent() {
    // Step counters
    document.querySelectorAll('.legu-step-counter').forEach((el, index) => {
      el.textContent = translations.stepCounter.replace('__NUM__', index + 1);
    });

    // Step 1 content
    document.querySelector('#legu-step-1 h2').textContent = translations.title1;
    document.querySelector('#legu-step-1 .legu-exit-intent-intro').textContent = translations.intro1;
    document.querySelector('#legu-step-1 h3').textContent = translations.question1;
    document.querySelector('#legu-step-1 .legu-note').textContent = translations.multipleAnswers;

    // Reasons
    document.querySelector('label[for="legu-price"]').textContent = translations.reason1;
    document.querySelector('label[for="legu-shipping-cost"]').textContent = translations.reason2;
    document.querySelector('label[for="legu-taste-doubt"]').textContent = translations.reason3;
    document.querySelector('label[for="legu-product-choice"]').textContent = translations.reason4;
    document.querySelector('label[for="legu-nutritional-info"]').textContent = translations.reason5;
    document.querySelector('label[for="legu-other"]').textContent = translations.reason6;
    document.querySelector('#legu-other-reason').placeholder = translations.reasonOtherPlaceholder;

    // Also sync the checkbox VALUES with the current language, so the webhook receives
    // the reason text in the user's language (matching what they saw on screen).
    const reasonInputs = [
      { id: 'legu-price', value: translations.reason1 },
      { id: 'legu-shipping-cost', value: translations.reason2 },
      { id: 'legu-taste-doubt', value: translations.reason3 },
      { id: 'legu-product-choice', value: translations.reason4 },
      { id: 'legu-nutritional-info', value: translations.reason5 },
      { id: 'legu-other', value: translations.reason6 }
    ];
    reasonInputs.forEach(r => {
      const el = document.getElementById(r.id);
      if (el) el.value = r.value;
    });

    // Step 2 content
    document.querySelector('#legu-step-2 h2').textContent = translations.title2;
    document.querySelector('#legu-step-2 .legu-exit-intent-intro').textContent = translations.intro2;
    document.querySelector('#legu-suggestion').placeholder = translations.suggestionPlaceholder;

    // Step 3 content
    document.querySelector('#legu-step-3 h2').textContent = translations.title3;
    document.querySelector('.legu-email-intro').textContent = translations.emailIntro;
    document.querySelector('#legu-email').placeholder = translations.emailPlaceholder;
    document.querySelector('.legu-email-note').textContent = translations.emailNote;

    // Buttons
    document.querySelectorAll('.legu-next-step').forEach(btn => {
      btn.textContent = translations.btnContinue;
    });
    document.querySelectorAll('.legu-back-step').forEach(btn => {
      btn.textContent = translations.btnBack;
    });
    document.querySelector('#legu-submit-feedback').textContent = translations.btnSubmit;

    // Success message
    document.querySelector('#legu-success-message h2').textContent = translations.successTitle;
    document.querySelector('#legu-success-message p').textContent = translations.successMessage;
  }

  // Initialize content with current language
  if (leguOverlay) {
    updateContent();

    // Toggle for "Other" field
    if (leguOtherCheckbox) {
      leguOtherCheckbox.addEventListener('change', function() {
        leguOtherReasonContainer.style.display = this.checked ? 'block' : 'none';
      });
    }

    // Update progress bar
    function leguUpdateProgressBar() {
      const progressPercentage = (leguCurrentStep / leguTotalSteps) * 100;
      leguProgressBar.style.width = `${progressPercentage}%`;
    }

    // Show exit intent (only on desktop)
    function leguShowExitIntent() {
      if (!leguIsDesktop()) {
        return; // Don't show popup on mobile/tablet
      }

      if (!leguExitIntentShown && !leguGetCookie(leguCookieName) && !leguIsCheckoutPage() && leguHasScrolledThreshold) {
        // Block background scroll
        document.body.classList.add('legu-popup-open');

        leguOverlay.style.display = 'flex';
        leguExitIntentShown = true;
        leguSetCookie(leguCookieName, 'true', leguCookieDuration);

        // Initialize view
        leguCurrentStep = 1;
        leguUpdateProgressBar();
      }
    }

    // Calculate scroll percentage
    function leguCalculateScrollPercentage() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );

      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;

      if (scrollPercentage >= leguScrollThreshold && !leguHasScrolledThreshold) {
        leguHasScrolledThreshold = true;
      }

      return scrollPercentage;
    }

    // Show specific step
    function leguShowStep(stepNumber) {
      leguSteps.forEach(step => {
        step.style.display = 'none';
      });
      const targetStep = document.getElementById(`legu-step-${stepNumber}`);
      if (targetStep) {
        targetStep.style.display = 'block';
        leguCurrentStep = stepNumber;
        leguUpdateProgressBar();

        // Manage required fields based on current step
        const suggestionField = document.getElementById('legu-suggestion');
        const emailField = document.getElementById('legu-email');

        if (suggestionField) {
          suggestionField.required = (stepNumber >= 2);
        }
        if (emailField) {
          emailField.required = (stepNumber >= 3);
        }
      }
    }

    // Next buttons
    leguNextButtons.forEach(button => {
      button.addEventListener('click', function() {
        const parentStep = this.closest('.legu-step');
        const currentStepNumber = parseInt(parentStep.getAttribute('data-step'));
        const nextStepNumber = currentStepNumber + 1;

        if (nextStepNumber <= leguTotalSteps) {
          leguShowStep(nextStepNumber);
        }
      });
    });

    // Back buttons
    leguBackButtons.forEach(button => {
      button.addEventListener('click', function() {
        const parentStep = this.closest('.legu-step');
        const currentStepNumber = parseInt(parentStep.getAttribute('data-step'));
        const prevStepNumber = currentStepNumber - 1;

        if (prevStepNumber >= 1) {
          leguShowStep(prevStepNumber);
        }
      });
    });

    // Don't show popup on checkout pages
    function leguIsCheckoutPage() {
      return window.location.href.indexOf('/checkout') !== -1 ||
             window.location.href.indexOf('/cart') !== -1;
    }

    // Monitor user scroll
    document.addEventListener('scroll', function() {
      leguCalculateScrollPercentage();
    });

    // Mouse leaves top of page (exit intent)
    document.addEventListener('mouseout', function(e) {
      if (e.clientY < 50 && !e.relatedTarget && !leguExitIntentShown) {
        leguShowExitIntent();
      }
    });

    // Close popup (only via X button)
    leguCloseBtn.addEventListener('click', function() {
      document.body.classList.remove('legu-popup-open');
      leguOverlay.style.display = 'none';
    });

    // Note: Removed click-outside-to-close functionality for better UX

    // Submit form
    leguForm.addEventListener('submit', function(e) {
      e.preventDefault();

      // Disable submit button to prevent multiple submissions
      const submitBtn = document.getElementById('legu-submit-feedback');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = translations.btnSubmitting;
      }

      // Collect form data
      const reasonsChecked = Array.from(leguForm.querySelectorAll('input[name="reason"]:checked'))
        .map(checkbox => checkbox.value);

      // Handle "Other" option
      let otherReasonText = '';
      if (leguOtherCheckbox && leguOtherCheckbox.checked) {
        const otherTextarea = document.getElementById('legu-other-reason');
        if (otherTextarea) {
          otherReasonText = otherTextarea.value;
        }
      }

      const suggestionTextarea = leguForm.querySelector('#legu-suggestion');
      const emailInput = leguForm.querySelector('#legu-email');

      const formData = {
        brand: 'LEGÙ',
        language: currentLanguage,

        // Step 1: Ragioni di abbandono
        abandonment_reasons: reasonsChecked.length > 0 ? reasonsChecked : [translations.notSpecified],
        abandonment_other_reason: otherReasonText,

        // Step 2: Suggerimenti per migliorare
        improvement_suggestion: suggestionTextarea ? suggestionTextarea.value : '',

        // Step 3: Contatto
        customer_email: emailInput ? emailInput.value : '',

        // Dati tecnici
        page_url: window.location.href,
        timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent,
        referrer: document.referrer
      };

      console.log('Legù Exit Intent - Sending data:', formData);

      // Send data to webhook
      fetch('https://hook.eu2.make.com/gq21senbt6k8b68s92freyyi7hyxmh3a', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        console.log('Legù Exit Intent - Response status:', response.status);
        return response.json().catch(() => ({ success: response.ok }));
      })
      .then(data => {
        console.log('Legù Exit Intent - Response data:', data);

        // Show success message
        leguForm.style.display = 'none';
        leguSuccessMessage.style.display = 'block';

        // Update progress bar to 100%
        leguProgressBar.style.width = '100%';

        // Close popup after some seconds
        setTimeout(function() {
          document.body.classList.remove('legu-popup-open');
          leguOverlay.style.display = 'none';
        }, 6000);
      })
      .catch(error => {
        console.error('Legù Exit Intent - Error:', error);

        // Show success message anyway for UX
        leguForm.style.display = 'none';
        leguSuccessMessage.style.display = 'block';
        leguProgressBar.style.width = '100%';

        setTimeout(function() {
          document.body.classList.remove('legu-popup-open');
          leguOverlay.style.display = 'none';
        }, 6000);
      })
      .finally(() => {
        // Re-enable submit button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = translations.btnSubmit;
        }
      });
    });

    // Make checkbox items fully clickable
    const leguCheckboxItems = document.querySelectorAll('.legu-checkbox-item');
    leguCheckboxItems.forEach(item => {
      item.addEventListener('click', function(e) {
        // Prevent default behavior for labels
        e.preventDefault();

        const checkbox = this.querySelector('input[type="checkbox"]');
        if (checkbox) {
          // Toggle checkbox state
          checkbox.checked = !checkbox.checked;

          // Handle "Other" checkbox toggle
          if (checkbox.id === 'legu-other') {
            leguOtherReasonContainer.style.display = checkbox.checked ? 'block' : 'none';
          }

          // Trigger change event for any other listeners
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // Prevent label from interfering with our custom click handler
      const label = item.querySelector('label');
      if (label) {
        label.addEventListener('click', function(e) {
          e.preventDefault();
        });
      }
    });

    // Initialize display
    leguUpdateProgressBar();
  }
});